import React from 'react';
import classNames from 'classnames';

import styles from './ConfVariantPicker.module.less';
import AbstractPicker, { connect } from '../AbstractPicker';
import { translate } from '../../../services/L10n';
import CircleOption from '../../CircleOption';
import { Icon } from '../../Icon';
import Tooltip from '../../Popup/Tooltip';
import { TOP } from '../../Popup/alignments';
import { t } from '../../../translations';

class ConfVariantPicker extends AbstractPicker {
  state = {
    options: [],
  };

  icons = {
    wire: {
      tooltip: translate(t.TOOLTIP_TYPE_WIRE),
      type: 'select',
      sort: 1,
    },
    metal: {
      tooltip: translate(t.TOOLTIP_METAL),
      type: 'select',
      sort: 2,
    },
    particleboard: {
      tooltip: translate(t.TOOLTIP_TYPE_PARTICLEBOARD),
      type: 'select',
      sort: 3,
    },
    mesh: {
      tooltip: translate(t.TOOLTIP_TYPE_MESH),
      type: 'select',
      sort: 2,
    },
    mesh_anthracite: {
      tooltip: translate(t.TOOLTIP_MESH_ANTHRACITE),
      type: 'select',
      sort: 2,
    },
    textile: {
      tooltip: translate(t.TOOLTIP_TEXTILE),
      type: 'select',
      sort: 3,
    },
    pads: {
      iconName: 'WheelsIcon',
      tooltip: translate(t.TOOLTIP_REMOVE_CASTORS),
      type: 'select',
      highlighted: true,
      sort: 1,
    },
    castors: {
      iconName: 'WheelsIcon',
      tooltip: translate(t.TOOLTIP_ADD_CASTORS),
      type: 'select',
      sort: 2,
    },
    empty: {
      iconName: 'DoorsIcon',
      tooltip: translate(t.TOOLTIP_REMOVE_CABINET),
      type: 'toggle',
      highlighted: true,
    },
    doors: {
      iconName: 'DoorsIcon',
      tooltip: translate(t.TOOLTIP_ADD_CABINET),
      type: 'toggle',
    },
    short: {
      iconName: 'RotateLeftIcon',
      tooltip: translate(t.TOOLTIP_ROTATE),
      type: 'toggle',
    },
    narrow: {
      iconName: 'RotateLeftIcon',
      tooltip: translate(t.TOOLTIP_ROTATE),
      type: 'toggle',
    },
  };

  itemsAsOptions(items, includeColor) {
    return items
      .map(item => ({
        value: item.filter.variant,
        color: includeColor ? item.filter.color : null,
        id: item.id,
        modelid: item.modelid,
        type: item.filter.type,
      }))
      .sort((a, b) =>
        this.icons[a.value].sort > this.icons[b.value].sort ? 1 : -1
      );
  }

  render() {
    const { selected, disabled, moveOthers, useColorSpecificIcon } = this.props;
    const options = this.itemsAsOptions(this.props.items, useColorSpecificIcon);
    return (
      <div className={classNames(styles['outer-wrapper'])}>
        {this.props.showHeadline && (
          <div className={classNames(styles.headline)}>
            {translate(t.TYPE)}:
          </div>
        )}
        <div
          className={classNames(
            styles['inner-wrapper'],
            options.length > 1 ? styles.radioButton : styles.toggle
          )}
        >
          {options.map((option, index) => {
            const highlighted =
              (options.length > 1 &&
                this.isSelected(option, selected, 'variant')) ||
              this.icons[option.value].highlighted;

            if (this.icons[option.value].iconName) {
              return (
                <div
                  key={index}
                  className={classNames(
                    styles.icon,
                    highlighted && styles.highlighted,
                    disabled && styles.disabled
                  )}
                  onClick={() =>
                    this.switch({
                      from: selected,
                      to: option,
                      switchingProp: 'variant',
                      moveOthers,
                    })
                  }
                >
                  <Tooltip
                    alignment={TOP}
                    spacing={2}
                    ignorePadding={true}
                    content={this.icons[option.value].tooltip}
                  >
                    <Icon iconName={this.icons[option.value].iconName} />
                  </Tooltip>
                </div>
              );
            }

            return (
              <CircleOption
                key={index}
                disabled={disabled}
                type={selected.filter.type}
                name={option.value + (option.color ? `_${option.color}` : '')}
                selected={highlighted}
                iconName={this.icons[option.value].iconName}
                onClick={() =>
                  this.switch({
                    from: selected,
                    to: option,
                    switchingProp: 'variant',
                    moveOthers,
                  })
                }
                tooltipContent={this.icons[option.value].tooltip}
                dataTestId={`variant-picker-${index}`}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export { ConfVariantPicker };
export default connect(ConfVariantPicker);
